import {  useState } from 'react';

import {obtenerActividadesFecha,ingresarActividadFecha,obtenerActividadFecha,actualizarActividadFecha} from '../data/ActividadesFecha';
    
import { useContext } from "react";
import { AuthContext } from "auth";


export const useActividadesFecha= (actividadId,actividadFechaId) => {
    var {user}= useContext(AuthContext);
    //const [actividadesFecha,setActividadesFecha]=useState([]);
    const [respuestaIngresarActividadFecha, setRespuestaIngresarActividadFecha] = useState({mensajeTexto:"",estado:false});

    const [actividadFechaPorActualizar, setActividadFechaPorActualizar] = useState({});
    const [respuestaActualizarActividadFecha, setRespuestaActualizarActividadFecha] = useState({mensajeTexto:"",estado:false});
    
    const updateRespuestaIngresarActividadFecha=async =>{
        setTimeout(function() {
            setRespuestaIngresarActividadFecha({mensajeTexto:"",estado:false});
        }, 4000);
    }
    const updateRespuestaActualizarActividadFecha=async =>{
        setTimeout(function() {
            setRespuestaActualizarActividadFecha({mensajeTexto:"",estado:false});
        }, 4000);
    }
    const getActividadesFecha= async() => {
        if(actividadId!=undefined){
            const respuesta=await obtenerActividadesFecha(actividadId,user.Token);
            //setActividadesFecha(respuesta)
            return respuesta;
        }
        return null;
    }
    const getActividadFecha= async() => {
        if(actividadFechaId!=undefined){
            const respuesta=await obtenerActividadFecha(actividadFechaId,user.Token);
            setActividadFechaPorActualizar(respuesta)
        }
    }
  
    const insertActividadFecha=async(ActividadFechaPorIngresar)=>{
        if(ActividadFechaPorIngresar!=null){
            ActividadFechaPorIngresar.ActividadTerapeuticaId=actividadId;
            const respuesta=await ingresarActividadFecha(ActividadFechaPorIngresar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaIngresarActividadFecha({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaIngresarActividadFecha({estado:false,mensajeTexto:"Se produjo un error"})
            }
            
            return respuesta;
        }
    }
    const updateActividadFecha=async(ActividadFechaPorActualizar)=>{
        if(ActividadFechaPorActualizar!=null){
            ActividadFechaPorActualizar.ActividadId=actividadId;
            ActividadFechaPorActualizar.ActividadFechaId=actividadFechaId;
            const respuesta=await actualizarActividadFecha(ActividadFechaPorActualizar,user.Token);
            if(respuesta!=undefined)
            {
                setRespuestaActualizarActividadFecha({estado:respuesta.success,mensajeTexto:respuesta.message})
            }
            else
            {
                setRespuestaActualizarActividadFecha({estado:false,mensajeTexto:"Se produjo un error"})
            }
            return respuesta;
        }
    }
    

    return {
        
        getActividadesFecha,
        updateRespuestaIngresarActividadFecha,
        insertActividadFecha,
        respuestaIngresarActividadFecha,
        updateActividadFecha,
        actividadFechaPorActualizar,
        respuestaActualizarActividadFecha,
        setActividadFechaPorActualizar,
        updateRespuestaActualizarActividadFecha,
        getActividadFecha
    }
}
